import useSWR from "swr";

import { getFetcher, useFetcher } from "../../hooks/useFetcher";
import { Article, ArticleResponse } from "../../types/article";
import { decode } from "../../utils";

export const GetArticleKey = (key: string) => `/articles/v2/${key}`;

export const useGetArticle = ({ key }: { key: string }) => {
  return useSWR<Article>(
    GetArticleKey(key),
    useFetcher(undefined, ({ data }) =>
      decode(ArticleResponse.safeParse(data)),
    ),
  );
};

export async function getArticle({ key }: { key: string }): Promise<Article> {
  const fetcher = getFetcher<Article>(undefined, ({ data }) =>
    decode(ArticleResponse.safeParse(data)),
  );
  return fetcher(GetArticleKey(key));
}
